/* eslint-disable jsx-a11y/media-has-caption */
import { Helmet } from 'react-helmet-async';
import { Stack, Container, Typography, Card, Box, styled, Grid, Divider, Button } from '@mui/material';
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
import useGetDirectory from '../hooks/useGetDirectory';
import Label from '../components/label/Label';
import vendorCategories from '../_mock/categories';
import { auth } from '../firebase';
import Iconify from '../components/iconify';
import useGetAllExploreAlbums from '../hooks/useGetAllExploreAlbums';
// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const content = useGetAllExploreAlbums()
  const navigate = useNavigate()
  const directories = useGetDirectory()
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  const settings2 = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoPlay:true
  };

  const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  });
  const StyledProductBig = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
  });

  const provinces = [
    "Central",
    "Copperbelt",
    "Eastern",
    "Luapula",
    "Lusaka",
    "Muchinga",
    "Northern",
    "North-Western",
    "Southern",
    "Western"
  ];


  
const shuffleArray = (array) => {
  // eslint-disable-next-line no-plusplus
  for (let i = array?.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const shuffledQuestions = content && shuffleArray(content);

  return (
   <>
      <Helmet>
        <title> Home</title>
      </Helmet>

      <Container>
        
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h6" gutterBottom>
             Spotlight
          </Typography> 
          </Stack>

<Grid container spacing={3}>
  <Grid item xs={12} md={4}>
  <Card sx={{p:3, height:"100%", justifyContent:"center"}}>
  <Typography variant='h4'>A community of experts and home owners</Typography><br/>
    <Typography>
 Whether you're looking for inspiration for your dream,
  need expert advice, or want to track your progress, 
  we've got you covered one step at a time.
 
    </Typography>
  </Card>
  </Grid> 


 <Grid item xs={12} md={8}>
            <Slider {...settings2}>
          {directories && directories.slice(0,3).map((d, index)=>(
            <div  key={index} style={{height:"100%"}}>
          <Card sx={{m:1}}  onClick={auth.currentUser?.uid === undefined ? ()=>navigate("/login") :()=>navigate(`/dashboard/vendorPage/${d.id}`, {state : d})}>
      <Box sx={{ pt: '35%', position: 'relative' }}>
       
          <Label
            variant="filled"
            color={'success'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase',
            }}
          >
            {d.category}
          </Label>
    
        <StyledProductBig alt={d.name} src={d.cover_image} />
        <Stack spacing={2} justifyContent={"space-between"} direction="row" sx={{ p: 3 , backgroundColor:"rgba(0,0,0,0.5)", position:"absolute",   bottom:0, left:0, right:0, zIndex:20000}}>
          <Typography variant="h3" noWrap>
            {d.name}<br/>
           
          </Typography>
          <Typography
              variant="overline"             
            >
        {d.phone}<br/>
        <Typography
              component="span"             
            >
        {d.province}
            </Typography>   
            </Typography>   
       </Stack>
      </Box>

    
    </Card>
    </div>
          ))
    }
    </Slider>
</Grid>
</Grid>
{/* <Stack direction="row" alignItems="center" justifyContent="space-between" my={5}>
          <Typography variant="h6" gutterBottom>
            Featured
          </Typography> 
         
        </Stack> */}
        {/* <Slider {...settings}>
         {directories && directories.map((d, index)=>(
          <div  key={index}>
          <Card sx={{m:1}} onClick={auth.currentUser?.uid === undefined ? ()=>navigate("/login") :()=>navigate(`/dashboard/vendorPage/${d.id}`, {state : d})}>
      <Box sx={{ pt: '100%', position: 'relative' }}>
       
          <Label
            variant="filled"
            color={'info'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase',
            }}
          >
            {d.category}
          </Label>
    
        <StyledProductImg alt={d.name} src={d.cover_image} />
      </Box>

      <Stack spacing={2} justifyContent={"space-between"} direction="row" sx={{ p: 3 }}>
          <Typography variant="subtitle2" noWrap>
            {d.name}
          </Typography>
      
              <Typography
              variant="overline"             
            >
        {d.phone}
            </Typography>           
         
       </Stack>
    </Card>
    </div>
         ))}
        </Slider>         */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" my={5}>
          <Typography variant="h6" gutterBottom>
              Locations
          </Typography>         
        </Stack> 
        <Grid container spacing={3}>
        {provinces.map((v, index)=>(
          <Grid item xs={6} md={2} key={index} onClick={()=>navigate("/dashboard/search", {state: {province : v, type : "PROVINCE"}})}>
          <Card sx={{p:3, height:"100%"}}>
            <Box style={{height:"100%"}}>
            <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography variant='body1' sx={{textAlign:"center", fontSize:14}}>{v}</Typography>
              <Iconify icon="eva:search-fill" />
            </Stack>              
            </Box>
          </Card>
          </Grid>
        ))}
        </Grid>

        {/* <Stack direction="row" alignItems="center" justifyContent="space-between" my={5}>
          <Typography variant="h6" gutterBottom>
              Explore
          </Typography>         
          <Button variant="text" color="success" gutterBottom onClick={()=>navigate("/dashboard/explore")} >
              View more
          </Button>         
        </Stack> 
        {content && <Grid container spacing={0.4} >
            {shuffledQuestions.slice(0,4).map((c, index)=>(                
                    c.images.slice(0,1).map((i, index)=>(
                        <Grid item xs={3} md={3} key={index} >
                             <img src={i} alt={c.name} style={{width:"100%", height:"100%", objectFit:"cover"}} />
                        </Grid>
                    ))
                
            ))}
        </Grid>} */}


        <Stack direction="row" alignItems="center" justifyContent="space-between" my={5}>
          <Typography variant="h6" gutterBottom>
              Category
          </Typography>         
        </Stack>
        <Grid container spacing={3}>
       
      
        {vendorCategories.slice(0,16).map((v, index)=>(
          <Grid item xs={6} md={3} key={index} onClick={()=>navigate("/dashboard/search", {state: {category : v.category, type : "CATEGORY"}})}>
          <Card sx={{p:3, height:"100%"}}>
            <Box style={{height:"100%"}}>
              <Typography variant='body1' sx={{textAlign:"center", fontSize:14}}>{v.category}</Typography>
              {/* <Divider sx={{my:2}}>x</Divider>
              <Typography variant='body1' sx={{textAlign:"center", fontSize:12}}>{v.description}</Typography> */}
            </Box>
          </Card>
          </Grid>
        ))}

        <Grid xs={12} md={12} sx={{mt:5, display:"flex", justifyContent:"center"}}>
        <video width="95%" height="340" style={{objectFit:"cover"}} controls={false} autoPlay loop>
        
  <source src="/assets/images/vid1.mp4" type="video/mp4" />
</video>
        </Grid>
         <Grid item xs={12} md={12}>
         <Typography variant="h6" gutterBottom>
             About Us
             </Typography>
             <Card sx={{p:3}}>
              <Box>
              <Typography variant='body1' sx={{textAlign:"center"}}>
Our mission is to empower homeowners, building experts and suppliers to transform their dreams, customers and businesses. We offer a vast array of useful features, connecting you with professionals who can bring those ideas to fruition.
<br/><br/>
With our platform, you can explore thousands of profiles for every part of your building process for your home, from the ground up to the bedrooms and kitchens to bathrooms and outdoor spaces. 
Our platform features profiles of various experts, including carpenters, contractors, interior designers, and more, all ready to turn your vision into reality.
<br/><br/>
We simplify the process by providing a seamless experience, from design discovery to professional connections. We also offer enough tools for a seamless and hussle free building journey.
<br/><br/>
Join us and embark on your journey towards a beautifully designed and renovated home, wherever you are.
          </Typography>
              </Box>
             </Card>
             {/* Video by Kindel Media: https://www.pexels.com/video/video-of-a-house-interior-7578546/ */}
         </Grid>
        </Grid>
      </Container>
    </>
  );
}
